import { render } from "./CalendarioEventos.vue?vue&type=template&id=0fc1e53c&scoped=true&ts=true"
import script from "./CalendarioEventos.vue?vue&type=script&lang=ts"
export * from "./CalendarioEventos.vue?vue&type=script&lang=ts"

import "./CalendarioEventos.vue?vue&type=style&index=0&id=0fc1e53c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc1e53c"]])

export default __exports__